import React from 'react';
import './Filter.css';

import Flex from '../Flex/Flex';
import Text from '../Text/Text';
import classNames from 'classnames';

export type FilterOption = {
  id: number;
  label: string;
};

type Props = {
  label: string;
  icon: React.ReactNode;
  options: Array<FilterOption>;
  value?: number;
  onChange: (id?: number) => void;
  additionalContent?: React.ReactNode;
  allSelectedFunction?: () => boolean;
};

const Filter = React.memo(
  ({ label, icon, options, value, onChange, additionalContent, allSelectedFunction }: Props) => {
    return (
      <Flex vertical gap={8}>
        <Flex align="center" className="Filter__labelContent">
          <i className="Filter__icon">{icon}</i>
          <Text size={2} type="secondary">
            {label}
          </Text>
        </Flex>

        <Flex className="Filter__content" align="center">
          <Flex gap={4}>
            {options.map((x) => (
              <Flex
                key={x.id}
                className={classNames('Filter__Option', {
                  'Filter__Option--active': value === x.id,
                })}
                align="center"
                onClick={() => {
                  if (value !== x.id) {
                    onChange(x.id);
                  }
                }}
              >
                <Text size={1} bold>
                  {x.label}
                </Text>
              </Flex>
            ))}
            <div
              className={classNames('Filter__Option', {
                'Filter__Option--active': allSelectedFunction
                  ? allSelectedFunction()
                  : value === undefined,
              })}
              onClick={() => {
                onChange();
              }}
            >
              <Text size={1} bold>
                All
              </Text>
            </div>
          </Flex>
          {additionalContent}
        </Flex>
      </Flex>
    );
  },
);

export default Filter;
